var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.125C4.5 4.77982 4.77982 4.5 5.125 4.5H18.875C19.2202 4.5 19.5 4.77982 19.5 5.125C19.5 5.47018 19.2202 5.75 18.875 5.75H5.125C4.77982 5.75 4.5 5.47018 4.5 5.125Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7C17.6904 7 18.25 7.55964 18.25 8.25V15.75C18.25 16.4404 17.6904 17 17 17H13.875C13.1846 17 12.625 16.4404 12.625 15.75V8.25C12.625 7.55964 13.1846 7 13.875 7H17ZM17 15.75V8.25H13.875V15.75H17Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 8.25C5.75 7.55964 6.30964 7 7 7H10.125C10.8154 7 11.375 7.55964 11.375 8.25V18.875C11.375 19.5654 10.8154 20.125 10.125 20.125H7C6.30964 20.125 5.75 19.5654 5.75 18.875V8.25ZM10.125 8.25H7V18.875H10.125V8.25Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignTop);
export default __webpack_public_path__ + "static/media/align-top.574b26005739e81fc63d23e5eadce013.svg";
export { ForwardRef as ReactComponent };